import { useEffect, useRef } from "react";

import {
    resolveChiliPiperSlug,
    useAccountManagersQuery,
} from "app/pages/sales-intelligence/sub-modules/account-manager/queries/useAccountManagersQuery";
import { allTrackers } from "app/services/track/track";

import type { IBookMeetingButtonProps } from "./BookMeetingButton";
import { BookMeetingButton } from "./BookMeetingButton";

type Props = Omit<IBookMeetingButtonProps, "slug">;

/**
 * Renders {@link BookMeetingButton} only when the current account has a
 * Salesforce Account Manager (or Account Success Manager) whose ChiliPiper
 * personal-link slug was successfully resolved by the backend.
 */
export const BookMeetingButtonWithAccountManagerGuard = (props: Props) => {
    const { data, isSuccess } = useAccountManagersQuery();
    const slug = resolveChiliPiperSlug(data);

    const hasTrackedMissing = useRef(false);

    useEffect(() => {
        if (isSuccess && !slug && !hasTrackedMissing.current) {
            hasTrackedMissing.current = true;
            allTrackers.dispatchTrackEvent("SI Hooks", "display", "book a meeting/missing");
        }
    }, [isSuccess, slug]);

    if (!slug) {
        return null;
    }

    return (
        <BookMeetingButton
            {...props}
            slug={slug}
        />
    );
};
